import _ from "lodash";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { myTasksIncidentstListName } from "src/api/config/myTasksInc.config";
import { actionsStatus, FiveWhyType, incStatus, isStrapi } from "src/api/config/systemSwitch";
import Loading from "src/components/Loading";
import ListIncMainPageTable from "src/components/tables/listIncMainPageTable.mobile";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";

type ListIncMainPageProps = {
    id: string;
    type: string;
    openComponentId: string;
    setOpenComponentId: React.Dispatch<React.SetStateAction<string>>;
    email?: string;
}

const ListIncMainPage = ({ id, type, openComponentId, setOpenComponentId, email }: ListIncMainPageProps) => {

    const [itemsInc, setItemsInc] = useState<any>([]);
    const currentUser: any = useAppSelector(selectCurrentUser);
    const [customLoading, setCustomLoading] = useState(true);
    const location = useLocation();
    const dispatch = useAppDispatch();

    const isOpen = openComponentId === id;

    useEffect(() => {
        if (currentUser.email) {
            setCustomLoading(true);
            getItemsRequest({
                listName: myTasksIncidentstListName,
                filters: { Questions: [type], ResponsibleEmail: email && `${email}*` || `${currentUser.email}*`, Status: [incStatus.process, incStatus.old] },
                sortOrder: { name: "DateIncidents2", desc: true }
            }).then((results) => {
                const { items } = results;
                if (items.length > 0) {
                    let incIds: string[] = [];
                    let emails: any = [];
                    let requests5Way: any = [];
                    items.map((item: any) => {
                        if (item.Questions && item.Questions.indexOf("Несоответствие") !== -1) {
                            const qFields = JSON.parse(item.Questions);
                            incIds = [
                                ...incIds,
                                `${qFields["IncidentOption"]}_${item["TypeIncident"].get_lookupValue()}_${item.ID}*`.toLowerCase(),
                            ];
                        }
                        if (item.ResponsibleEmail) {
                            emails = [...emails, item.ResponsibleEmail.toLowerCase()];
                        }
                        if (item.AuthorEmail) {
                            emails = [...emails, item.AuthorEmail.toLowerCase()];
                        }
                        requests5Way = [
                            ...requests5Way,
                            getItemsRequest({ listName: myTasks5WayListName, filters: { Incident: item.ID } }),
                        ];
                    });
                    dispatch(addUsers(emails));
                    Promise.all(requests5Way).then((values: any) => {
                        let cards5Way: any = [],
                            cards5WayIds: any = [],
                            deviationCardsIds: any = [];
                        values.map((results: any) => {
                            cards5Way = [...cards5Way, ...results["items"]];
                        });
                        cards5Way
                            .filter((card5Way: any) => card5Way.Type5Way === FiveWhyType)
                            .map((card5Way: any) => {
                                cards5WayIds = [...cards5WayIds, card5Way.ID];
                            });
                        cards5Way
                            .filter((card5Way: any) => card5Way.Type5Way === "DeviationReport")
                            .map((card5Way: any) => {
                                deviationCardsIds = [...deviationCardsIds, card5Way.ID];
                            });
                        Promise.all([
                            getItemsRequest({
                                listName: myTasksSDCA5WayListName,
                                filters: { _x0035_Way: (cards5WayIds.length > 0 && cards5WayIds) || [0] },
                            }),
                            getItemsRequest({
                                listName: myTasksSDCA5WayListName,
                                filters: { _x0035_Way: (deviationCardsIds.length > 0 && deviationCardsIds) || [0] },
                            }),
                        ]).then((values: any) => {
                            let arrRequests: any = [];
                            let sdcaItemsAll: any = {
                                cards5Way: [],
                                deviationCards: [],
                            };
                            values.map((results: any, idx: number) => {
                                if (idx === 0) {
                                    sdcaItemsAll["cards5Way"] = [...results.items];
                                } else {
                                    sdcaItemsAll["deviationCards"] = [...results.items];
                                }
                                const sdcaItems = [...results.items];
                                sdcaItems.map((item) => {
                                    arrRequests = [
                                        ...arrRequests,
                                        getItemsRequest({
                                            listName: myTaskActionsListName,
                                            filters: {
                                                ImportantHashTag: (idx === 0 && `#5Почему_${item.ID}*`) || `#Отчет_об_отклонениях_${item.ID}*`,
                                            },
                                        }),
                                    ];
                                });
                            });
                            Promise.all(arrRequests).then((values) => {
                                let actions: any = [];
                                values.map((value) => {
                                    actions = [...actions, ...value.items];
                                });
                                const returnItemsCards5Way = cards5Way
                                    .filter((card5Way: any) => card5Way.Type5Way === FiveWhyType)
                                    .map((item: any) => {
                                        const currentSdcaItems = sdcaItemsAll["cards5Way"].filter(
                                            (sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === item.ID
                                        );
                                        let currentActions: any = [];
                                        currentSdcaItems.map((currentSdcaItem: any) => {
                                            currentActions = [
                                                ...currentActions,
                                                ...actions.filter(
                                                    (action: any) => action.ImportantHashTag.indexOf(`#5Почему_${currentSdcaItem.ID}`) !== -1
                                                ),
                                            ];
                                        });
                                        return {
                                            ...item,
                                            actions: currentActions,
                                        };
                                    });
                                const returnItemsDeviationCards = cards5Way
                                    .filter((card5Way: any) => card5Way.Type5Way === "DeviationReport")
                                    .map((item: any) => {
                                        const currentSdcaItems = sdcaItemsAll["deviationCards"].filter(
                                            (sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === item.ID
                                        );
                                        let currentActions: any = [];
                                        currentSdcaItems.map((currentSdcaItem: any) => {
                                            currentActions = [
                                                ...currentActions,
                                                ...actions.filter(
                                                    (action: any) =>
                                                        action.ImportantHashTag.indexOf(`#Отчет_об_отклонениях_${currentSdcaItem.ID}`) !== -1
                                                ),
                                            ];
                                        });
                                        return {
                                            ...item,
                                            actions: currentActions,
                                        };
                                    });
                                const cards5WayData = [...returnItemsCards5Way, ...returnItemsDeviationCards];
                                getItemsRequest({
                                    listName: myTaskActionsListName,
                                    viewFields: ["ID", "Status", "Description", "ImportantHashTag"],
                                    filters: { ImportantHashTag: (incIds.length > 0 && incIds) || ["0"] },
                                }).then((results) => {
                                    let actions = [...results.items];
                                    let returnItems = items.map((item: any) => {
                                        let actionsIncStatus: any = { name: "В процессе", color: "#F2A900" };
                                        let currentActions: any = [];
                                        if (item.Questions && item.Questions.indexOf("Несоответствие") !== -1) {
                                            const qFields = JSON.parse(item.Questions);
                                            currentActions = actions.filter(
                                                (action: any) =>
                                                    action.ImportantHashTag.indexOf(
                                                        `${qFields["IncidentOption"]}_${item["TypeIncident"].get_lookupValue()}_${item.ID
                                                            }`.toLowerCase()
                                                    ) !== -1
                                            );
                                        }
                                        const card5WayInc =
                                            (cards5WayData.filter((card5way: any) => card5way.Incident.get_lookupId() === item.ID).length >
                                                0 &&
                                                cards5WayData.filter((card5way: any) => card5way.Incident.get_lookupId() === item.ID)[0]) ||
                                            null;
                                        if (card5WayInc) {
                                            currentActions = [...currentActions, ...card5WayInc["actions"]];
                                        }
                                        if (currentActions.length === 0) {
                                            actionsIncStatus = { name: "Нет действий", color: "#FDE5D8" };
                                        } else if (currentActions.length > 0 && currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.old)
                                        ) {
                                            actionsIncStatus = { name: "Просрочено", color: "#F23030" };
                                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.cancel).length === currentActions.length
                                        ) {
                                            actionsIncStatus = { name: "Отменено", color: "#6B7280" };
                                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.closed).length === currentActions.length
                                        ) {
                                            actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === currentActions.length) {
                                            actionsIncStatus = { name: "Не начато", color: "#FDE5D8" };
                                        } else if (currentActions.length > 0 && (currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.cancel) || currentActions.some((action: any) => action.Status.get_lookupId() === actionsStatus.closed)) && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.notStart).length === 0) {
                                            actionsIncStatus = { name: "Закрыто", color: "#22AD5C" };
                                        } else if (currentActions.length > 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.old).length === 0 && currentActions.filter((action: any) => action.Status.get_lookupId() === actionsStatus.process).length > 0
                                        ) {
                                            actionsIncStatus = { name: "В процессе", color: "#F2A900" };
                                        }
                                        return {
                                            ...item,
                                            tree:
                                                (card5WayInc &&
                                                    card5WayInc.Tree &&
                                                    JSON.parse(card5WayInc.Tree)
                                                        .filter((treeItem: any) => treeItem.root)
                                                        .map((treeItem: any) => treeItem.reason)
                                                        .join(`,\u000A`)) ||
                                                "-",
                                            actions: currentActions,
                                            actionsIncStatus,
                                        };
                                    });
                                    setItemsInc([...returnItems]);
                                    setCustomLoading(false);
                                });
                            });
                        });
                    });
                } else {
                    setItemsInc([]);
                    setCustomLoading(false);
                }
            });
        }
    }, [currentUser, location]);

    return (
        <section className="mb-7.5 cursor-pointer w-full flex-col flex">
            <FlexRow onClick={() => setOpenComponentId(isOpen ? "" : id)} className="w-full flex justify-between items-center mb-5">
                <h3 className="text-[#637381] flex items-center font-medium text-[14px]">
                    {type.indexOf('Несоответствие') !== -1 &&
                        <>
                            Несоответствия · {customLoading && <>&nbsp;<Loading /></> || itemsInc.length}
                        </> || type.indexOf('Инцидент') !== -1 &&
                        <>
                            Инциденты · {customLoading && <>&nbsp;<Loading /></> || itemsInc.length}
                        </>
                    }
                </h3>
                {!isOpen &&
                    <ArrowDown />
                    ||
                    <ArrowUp />
                }
            </FlexRow>
            {isOpen &&
                <FlexCol className="w-full gap-5">

                    {customLoading && <div className="mt-5 mb-5 flex items-center justify-center w-full"><Loading /></div> ||
                        <>
                            <FlexRow className="w-full items-center justify-center bg-white p-4 rounded-lg shadow-custom">
                                <FlexCol className="gap-[10px] sm:flex-row">
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="#F2A900" />
                                    </svg>&nbsp;&nbsp;<span className={`text-[#F2A900]`}>В процессе&nbsp;&nbsp;{itemsInc.filter((action: any) => action.Status.get_lookupId() === incStatus.process).length}</span></span>
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill="#BA0C2F" />
                                    </svg>&nbsp;&nbsp;<span className={`text-[#BA0C2F]`}>Просрочено&nbsp;&nbsp;{itemsInc.filter((action: any) => action.Status.get_lookupId() === incStatus.old).length}</span></span>
                                </FlexCol>
                            </FlexRow>
                            <ListIncMainPageTable data={itemsInc} type={type} />
                        </>
                    }
                </FlexCol>
            }
        </section>
    );
};

export default ListIncMainPage;
